import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '../../../core/services/config/config.service';
import { UtilityService } from '../../../core/services/utility/utility.service';
import { FullPatientProfile } from '../../models/full-patient-profile';
import { PatientProfile } from '../../models/patient-profile';

@Injectable({
  providedIn: 'root',
})
export class PatientProfilesService {
  private utilityService = inject(UtilityService);
  private configService = inject(ConfigService);
  private config = this.configService.config;

  endpoint = `${this.config.patientApiUrl}/v1/PatientPortal/PatientProfile`;

  getPatientProfile(patientId: number): Observable<PatientProfile> {
    const url = `${this.endpoint}/${patientId}`;
    return this.utilityService.getRequest<PatientProfile>(url);
  }

  savePatientProfile(patientId: number, profile: PatientProfile): Observable<PatientProfile> {
    return this.utilityService.putRequest<PatientProfile>(`${this.endpoint}/${patientId}`, profile);
  }

  getFullPatientProfile(patientId: number): Observable<FullPatientProfile> {
    const url = `${this.endpoint}/${patientId}/FullProfile`;
    return this.utilityService.getRequest<FullPatientProfile>(url);
  }
}
